export const HeaderGlobalMenu = () => {

  const navItems = document.querySelectorAll('.nav-item.dropdown');

  navItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
          item.querySelector('.dropdown-menu').style.display = 'flex';
      });

      item.addEventListener('mouseleave', () => {
          item.querySelector('.dropdown-menu').style.display = 'none';
      });
  });

}






